import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JsonLd from "@/components/feature/JsonLd";
import { buildOrganizationSchema, buildWebSiteSchema } from "@/seo/schema";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import AboutSection from "./components/AboutSection";
import GuideSection from "./components/GuideSection";
import ArticlesSection from "./components/ArticlesSection";
import FaqSection from "./components/FaqSection";
import FinalCta from "./components/FinalCta";

export default function Home() {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.hash]);

  return (
    <>
      <JsonLd
        data={[buildOrganizationSchema(), buildWebSiteSchema(t("meta.home.description"))]}
      />
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <GuideSection />
        <ArticlesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}